import {
  IconArrowNarrowRight,
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandTwitter,
  IconBrandYoutube,
  IconBuilding,
  IconBulb,
  IconCalendar,
  IconCertificate,
  IconChartPie,
  IconCheck,
  IconChevronDown,
  IconChevronRight,
  IconChevronsRight,
  IconClock,
  IconCoffee,
  IconCurrencyDollar,
  IconHome,
  IconListCheck,
  IconMail,
  IconMapPin,
  IconMeat,
  IconMessages,
  IconMoodKid,
  IconPhone,
  IconPhoto,
  IconPin,
  IconPlayerPlayFilled,
  IconPlus,
  IconSend,
  IconStarFilled,
  IconUser,
  IconUsers,
  IconVirus,
} from '@tabler/icons-react';

const iconOptions = {
  calendar: IconCalendar,
  dollar: IconCurrencyDollar,
  user: IconUser,
  bulb: IconBulb,
  ratio: IconChartPie,
  home: IconHome,
  send: IconSend,
  mail: IconMail,
  pin: IconPin,
  building: IconBuilding,
  phone: IconPhone,
  messages: IconMessages,
  listCheck: IconListCheck,
  meat: IconMeat,
  virus: IconVirus,
  photo: IconPhoto,
  arrowNarrowRight: IconArrowNarrowRight,
  chevronsRight: IconChevronsRight,
  chevronRight: IconChevronRight,
  mapPin: IconMapPin,
  moodKid: IconMoodKid,
  clock: IconClock,
  users: IconUsers,
  playFilled: IconPlayerPlayFilled,
  starFilled: IconStarFilled,
  check: IconCheck,
  certificate: IconCertificate,
  coffee: IconCoffee,
  plus: IconPlus,
  chevronDown: IconChevronDown,
  instagram: IconBrandInstagram,
  facebook: IconBrandFacebook,
  youtube: IconBrandYoutube,
  twitter: IconBrandTwitter,
  linkedin: IconBrandLinkedin,
};

type IconName = keyof typeof iconOptions;

interface IconProps {
  icon: IconName;
  className?: string;
  stroke?: number;
}

export const Icon = ({ icon, className = '', stroke = 1.5 }: IconProps) => {
  const iconName = icon || (Object.keys(iconOptions)[0] as IconName);
  const IconSVG = iconOptions[iconName];
  return <IconSVG className={className} stroke={stroke} />;
};
